import {
  USER_INFO_SET,
  USER_INFO_CLEAR,
  USER_INFO_FAILED,
  UserInfoActionI,
} from "src/redux/actions/userInfo";
import { UserInfoClaimsI } from "src/types/User";

export interface UserInfoState {
  data: UserInfoClaimsI | null;
  loading: boolean;
  error: Error | null;
}

export const initialState: UserInfoState = {
  data: null,
  loading: true,
  error: null,
};

const userInfo = (
  state: UserInfoState = initialState,
  action: UserInfoActionI,
): UserInfoState => {
  switch (action.type) {
    case USER_INFO_SET:
      return { data: action.payload, loading: false, error: null };
    case USER_INFO_CLEAR:
      return { ...initialState };
    case USER_INFO_FAILED:
      return { data: null, loading: false, error: action.error };
    default:
      return state;
  }
};

export default userInfo;
